import { select, Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { CommunicationsState, STORE_FEATURE_KEY_COMMUNICATION } from './communications.reducer';
import { Observable } from 'rxjs/internal/Observable';
import { CategoryModel } from './communications.model';
const selectCommunicationState = (appState: any)=> <CommunicationsState>appState[STORE_FEATURE_KEY_COMMUNICATION]
const selectedCategorySelector = (communicationsState: CommunicationsState) => communicationsState.selectedCategory;
const loadingSelector = (communicationsState: CommunicationsState) => communicationsState.loading;

@Injectable({ providedIn: 'root' })
export class CommunicationsSelectors {
    constructor(private store: Store<any>) {
    }

    selectSelectedCategory(): Observable<CategoryModel> {
        return this.store.pipe(
          select(selectCommunicationState),
          select(selectedCategorySelector));
    }

    selectLoading(): Observable<boolean> {
        return this.store.pipe(
          select(selectCommunicationState),
          select(loadingSelector));
    }
}
